export const dashboard = {
  title: "Intuitive dashboard",
  subtitle: "Manage all your exchanges from a simple and modern interface",
  features: {
    stats: {
      title: "Detailed statistics",
      description: "Track your Nights, exchanges and savings in real time",
    },
    notifications: {
      title: "Smart notifications",
      description: "Receive alerts for new requests and important messages",
    },
    management: {
      title: "Simplified management",
      description:
        "Manage your availability, bookings and exchanges in just a few clicks",
    },
  },
  cta: "Discover the dashboard",
  exchangeConfirmed: "Exchange confirmed",
  newRequests: "new requests",
  toReview: "To review",
};
